module.exports = __webpack_public_path__ + "img/wrench-simple.21fc199f.svg";